import type { Invoice, InvoicingState, PaymentMethod, RecordedPayment } from './api'

export const PAYMENT_METHODS: { value: PaymentMethod; label: string }[] = [
  { value: 'check', label: 'Check' },
  { value: 'wire', label: 'Wire' },
  { value: 'ach', label: 'ACH' },
  { value: 'cash', label: 'Cash' },
  { value: 'card', label: 'Card' },
  { value: 'other', label: 'Other' },
]

const methodLabel = (method: RecordedPayment['method']) => PAYMENT_METHODS.find((item) => item.value === method)?.label

/** How it was paid, its reference and who recorded it: "Check · Ref 4417 · Dana Ruiz". */
export function paymentDetail(payment: RecordedPayment) {
  return [methodLabel(payment.method), payment.reference ? `Ref ${payment.reference}` : null, payment.recorded_by?.name]
    .filter(Boolean)
    .join(' · ')
}

/** The invoice a recorded payment pays: the one waiting for payment, if any. */
export function openInvoice(state: InvoicingState): Invoice | null {
  return [state.invoice, state.balance_invoice].find((item) => item?.finalized_at && item.status === 'open') ?? null
}
